export default {
    loading: false,
    alertType: null,
    alertMessage: null
}
